import { client } from '../libs/client';
import { news } from '../types/cms-types';

export interface FormattedNewsItem {
  id: string;
  title: string;
  category: string;
  href: string;
}

export const fetchNews = async (limit: number = 100): Promise<news[]> => {
  try {
    const response = await client.get({
      endpoint: 'news',
      queries: {
        limit,
        orders: '-publishedAt',
        depth: 2,
        filters: 'post_category[equals]news',
      },
    });
    return response.contents;
  } catch (error) {
    console.error('ニュースデータの取得に失敗しました:', error);
    throw error;
  }
};

export const formatNewsItems = (items: news[]): FormattedNewsItem[] => {
  return items.map((item) => ({
    id: item.id,
    title: item.post_title,
    category: 'お知らせ',
    href: `/2025/news/${item.id}`,
  }));
};

export const fetchAndFormatNews = async (limit: number = 100): Promise<FormattedNewsItem[]> => {
  const newsItems = await fetchNews(limit);
  return formatNewsItems(newsItems);
};

export const getNewsById = async (id: string): Promise<news | null> => {
  try {
    const response = await client.get({
      endpoint: 'news',
      contentId: id,
      queries: {
        depth: 2,
      },
    });
    return response;
  } catch (error) {
    console.error('ニュース詳細の取得に失敗しました:', error);
    return null;
  }
};
